import { Component } from '@angular/core';

@Component({
    selector: 'app-tasks',
    template: ` <router-outlet></router-outlet>`,
})
export class TasksPage {}
